module.exports = "<router-outlet></router-outlet>\n<!--<app-overlay></app-overlay>-->\n"